module.exports = __webpack_public_path__ + "img/mic6.49fd37a4.jpg";